<template>
<section>
    <div class="box">
    <nav class="level">
      <div class="level-left">
        <h4 class="subTitle">Configurações</h4>
      </div>
    </nav>
    <div v-if="showContent">
      <ContentLoading
        :show="showContent"
        :grid="grid"
        :width="300"
        :height="55.49"
        :mobile-grid="mobileGrid"
        :mobile-width="30"
        :mobile-height="20"
      />
      <p class="text-loading ml-2">Aguarde ...</p>
    </div>
    <div v-else>
       <ul class="cardConfig">
        <AppLink to="/configurations/events">
          <li>
            Ação
          </li>
        </AppLink>
        <AppLink to="/configurations/entities">
          <li>
            Dados
          </li>
        </AppLink>
      </ul>
    </div>
  </div> 
  <div class="level-right">
    <AppLink class="btnVoltar" to="/" name="Voltar" />
  </div>
</section>
</template>

<script>
import { AppLink } from '@/components'
import ContentLoading from '@/components/helpers/ContentLoading'

export default {
  name: 'ConfigurationsHome',
  components: {
    AppLink,
    ContentLoading
  },
  data: () => ({
    showContent: true,
    grid: [
      { x: 0, y: 0, rx: 2, ry: 2, innerWidth:64.91, innerHeight: 56 }
    ],
    mobileGrid: [
      { x: 0, y: 0, rx: 2, ry: 2, innerWidth:`${100}%`, innerHeight: `${100}%` }
    ]
  }),
  created(){
    setTimeout(() => {
      this.showContent = false
    }, 2000)
  }
}
</script>

<style lang="scss">
.cardConfig {
  width: 234px;
  height: 200px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: center;
    li {
    margin-bottom: 8px;
    width: 142px;
    height: 32px;
    border: 1px solid #2d9cdb;
    box-sizing: border-box;
    border-radius: 4px;
    background: #fff;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    }
    a {
      color: #2d9cdb;
      text-decoration: none;
    }
  }
.subTitle {
  font-weight: 500;
  font-size: 14px;
  color: #6D6D77;
  text-transform: uppercase;
  }
.btnNew {
  background-color: #2d9cdb;
}

.btnVoltar {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2D9CDB;
  border-radius: 4px;
  color: #fff;
  text-transform: uppercase;
  color: #fff;
  width: 80px;
  height: 40px;
 }


</style>
